import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import mixpanel, {
  IDENTIFY,
  PEOPLE_INCREMENT,
  TRACK_OPEN
} from "./store/mixpanel";
import { sdkIsReady, getContext } from "./utils/facebookWebview";
import { isKik } from "./utils/platform";
import createStore from "./store";
import bootStore from "./store/boot";
import timeStore from "./store/timer";
import App from "./App";

const preloadedState = window.__PRELOADED_STATE__;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares =
  process.env.NODE_ENV !== "development"
    ? applyMiddleware(thunk, mixpanel)
    : applyMiddleware(thunk, logger);
const enhancers = composeEnhancers(middlewares);
const store = createStore(preloadedState, enhancers);
const context = {};
const render = () =>
  ReactDOM.render(
    <Router basename={process.env.REACT_APP_BASE_NAME || ""} context={context}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    document.getElementById("root")
  );

window.startTimer = function() {
  if (window.stopTimer) window.stopTimer();
  window.stopTimer = timeStore(store);
};

if (isKik()) {
  initializeKik().catch(handleError);
} else {
  initializeFb().catch(handleError);
}

function initializeFb() {
  return sdkIsReady()
    .then(() => getContext(process.env.REACT_APP_MESSENGER_APP_ID))
    .then(({ psid }) => psid)
    .then(loadApplication);
}

function initializeKik() {
  return Promise.resolve()
    .then(() => window.kik.message.chatId)
    .then(loadApplication);
}

function loadApplication(user_id) {
  window.startTimer();

  store.dispatch({
    type: IDENTIFY,
    payload: user_id
  });

  store.dispatch({
    type: TRACK_OPEN
  });

  store.dispatch({
    type: PEOPLE_INCREMENT,
    payload: "webview_open_count"
  });

  return bootStore(store, { user_id }).then(() => render());
}

function renderErr(obj) {
  const parent = document.getElementById("root").parentElement;
  const element = document.createElement("pre");
  element.innerHTML = JSON.stringify(obj, null, 2);
  parent.appendChild(element);
}

function handleError(err) {
  console.log(err);
  if (process.env.NODE_ENV === "development") {
    loadApplication("1255458351169390");
  } else {
    window.location.href = "https://blinkthebee.com";
  }
}



// WEBPACK FOOTER //
// ./src/index.js